import React from 'react';
import { Avatar as AntAvatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { getImageUrl } from '../../services/uploadService';

interface UserAvatarProps {
  src?: string | null;
  firstName?: string;
  lastName?: string;
  size?: number;
  style?: React.CSSProperties;
}

/**
 * Composant Avatar avec initiales si pas d'image
 */
const UserAvatar: React.FC<UserAvatarProps> = ({
  src,
  firstName = '',
  lastName = '',
  size = 40,
  style = {},
}) => {
  // Générer les initiales
  const getInitials = () => {
    const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
    return `${firstInitial}${lastInitial}`.trim() || '?';
  };

  // Générer une couleur basée sur le nom
  const getBackgroundColor = () => {
    const name = `${firstName}${lastName}`.toLowerCase();
    const colors = [
      '#1890ff', // bleu
      '#52c41a', // vert
      '#faad14', // orange
      '#f5222d', // rouge
      '#722ed1', // violet
      '#13c2c2', // cyan
      '#eb2f96', // magenta
      '#fa8c16', // orange foncé
    ];
    
    // Hash simple du nom pour obtenir un index de couleur
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  if (src) {
    // Si une image existe, l'afficher avec l'URL complète
    const imageUrl = getImageUrl(src);
    return (
      <AntAvatar
        size={size}
        src={imageUrl}
        style={{
          border: '2px solid #f0f0f0',
          ...style,
        }}
        icon={<UserOutlined />}
      />
    );
  }

  // Sinon, afficher les initiales avec couleur
  return (
    <AntAvatar
      size={size}
      style={{
        backgroundColor: getBackgroundColor(),
        color: '#fff',
        fontWeight: 600,
        border: '2px solid #f0f0f0',
        ...style,
      }}
    >
      {getInitials()}
    </AntAvatar>
  );
};

export default UserAvatar;
